import { Injectable } from "@angular/core";
import { SMS_ENDPOINTS } from "../../components/mediaManager/campanias/sms/sms-endpoints";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ObservableDataService } from "../core/observable-data.service";
import { environment } from "../../../environments/environment";
import { Pagination } from "../../utils/types/shared/pagination";
import { SMSTemplate } from "../../utils/types/sms/sms-template.type";
import { PagedApiResponse } from "../../utils/types/shared/paged-api-response.type";

@Injectable({
    providedIn: "root",
})
export class SmsTemplateService {
    private URL = SMS_ENDPOINTS.template;

    constructor(private httpClient: HttpClient) {}

    public getTemplates(filter?: any) {
        let params = new HttpParams();

        if (
            filter?.limit &&
            (filter?.offset !== null || filter?.offset !== undefined)
        ) {
            params = params.set("limit", filter.limit);
            params = params.set("offset", filter.offset);
        }

        if (filter?.onlyactives) {
            params = params.set("onlyactives", filter.onlyactives);
        }

        return this.httpClient.get<PagedApiResponse<SMSTemplate>>(this.URL, {
            params,
        });
    }

    public createTemplate(template: SMSTemplate) {
        return this.httpClient.post(this.URL, template);
    }

    public updateTemplate(template: SMSTemplate) {
        return this.httpClient.put(this.URL, template);
    }

    public deleteTemplate(id: number) {
        return this.httpClient.delete(this.URL + `/${id}`);
    }
}
